import React from 'react';
import {
    MainContainer,
    RowHeader,
    CardTitle,
    ImageContainer,
} from './PriceOverrideRequestDetails.styled';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import Edit from 'src/assets/images/Edit.svg';

const CollapsableCard = ({
    title,
    onClick,
    isExpanded,
    children,
    margin,
    editButton,
    editPage,
    padding,
}) => {
    return (
        <>
            <MainContainer padding={padding} margin={margin}>
                <RowHeader
                id="orders-priceoverride-request-details-row-header"
                    onClick={onClick}
                    isExpanded={isExpanded}
                    style={{ cursor: 'pointer' }}
                >
                    <CardTitle>{title}</CardTitle>

                    {editButton ? (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div
                                id="orders-priceoverride-request-details-edit-button"
                                style={{
                                    width: '35px',
                                    height: '30px',
                                    marginRight: '15px',
                                    background:
                                        '#FFFFFF 0% 0% no-repeat padding-box',
                                    boxShadow: '0px 0px 0px #00000029',
                                    border: '1px solid #EBEDED',
                                    borderRadius: '6px',
                                    opacity: '1',
                                }}
                                onClick={() => editPage()}
                            >
                                <img
                                    style={{ padding: '1px 1px 1px 5px' }}
                                    src={Edit}
                                    alt="edit-button"
                                />
                            </div>
                            <ImageContainer
                                src={DownArrowFilter}
                                alt="down-arrow"
                                isExpanded={isExpanded}
                                style={{
                                    margin: '0 20px 0 0',
                                }}
                            />{' '}
                        </div>
                    ) : (
                        <ImageContainer
                            src={DownArrowFilter}
                            alt="down-arrow"
                            isExpanded={isExpanded}
                            style={{
                                margin: '0 20px 0 0',
                            }}
                        />
                    )}
                </RowHeader>
                {children}
            </MainContainer>
        </>
    );
};

export default CollapsableCard;
